import { useTranslation } from 'react-i18next'

import { Alert } from '@enechain/ecloud-designsystem'

type Props = {
  /** 表示中の受渡日の、 取り込み元で見つからなくなった札の件数。 */
  count: number
}

/**
 * 取り込み元で見つからなくなった入札中の札の警告 (AC-BIN-127)。 0 件なら何も描画しない。
 */
export const IntradayNeedsReviewBanner = ({
  count,
}: Props): React.ReactElement | null => {
  const { t } = useTranslation()
  if (count === 0) return null
  const prefix = 'page:biddingIntraday.needsReview'

  return (
    <Alert
      flexShrink={0}
      description={t(`${prefix}.alertBody`)}
      status="warning"
      title={t(`${prefix}.alertTitle`, { count })}
    />
  )
}
